<template>
  <div class="modal skin-modal sale-skin-modal">
    <div class="overlay" @click="$emit('closeSaleSkinModal')"></div>
    <div class="wrapper">
      <img class="close" @click="$emit('closeSaleSkinModal')" src="./../assets/close.svg"/>
      <div class="container">
        <form @submit.prevent="submitOffer">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title title-24">
                <b>{{ $t('Sell Your Skin') }}</b>
              </div>
              <div class="form-fields-wrapper">
                <label>
                  <div class="desc">{{ $t('Skin name') }}:</div>
                  <input v-model="formData.skinName" type="text" :placeholder="$t('Skin name')" required :disabled="isLoading"/>
                </label>
                <label>
                  <div class="desc">{{ $t('Desired price') }}:</div>
                  <input v-model="formData.desiredPrice" type="text" :placeholder="$t('Desired price')" required :disabled="isLoading"/>
                </label>
                <label>
                  <div class="desc">{{ $t('Exterior') }}:</div>
                  <select v-model="formData.exterior" class="select" required :disabled="isLoading">
                    <option value="" disabled selected>{{ $t('Select exterior') }}</option>
                    <option value="Factory New">{{ $t('Factory New') }}</option>
                    <option value="Minimal Wear">{{ $t('Minimal Wear') }}</option>
                    <option value="Field-Tested">{{ $t('Field-Tested') }}</option>
                    <option value="Well-Worn">{{ $t('Well-Worn') }}</option>
                    <option value="Battle-Scarred">{{ $t('Battle-Scarred') }}</option>
                    <option value="Not Painted">{{ $t('Not Painted') }}</option>
                  </select>
                </label>
                <label>
                  <div class="desc">{{ $t('Steam link') }}:</div>
                  <input v-model="formData.steamLink" type="url" :placeholder="$t('Steam inventory link to skin')" required :disabled="isLoading"/>
                </label>
                <transition name="slide">
                  <div v-if="error" class="error-desc desc red">{{ error }}</div>
                </transition>
                <div class="cta-container">
                  <div></div>
                  <button class="button" type="submit" :disabled="isLoading">
                    <span>{{ isLoading ? $t('Sending...') : $t('Send') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaleSkinModal',
  props: ['currency'],
  components: {
  },
  data: function() {
    return {
      formData: {
        skinName: '',
        desiredPrice: '',
        exterior: '',
        steamLink: ''
      },
      isLoading: false,
      error: ''
    }
  },
  methods: {
    extractApiErrorMessage(error) {
      const data = error?.response?.data;
      if (!data) {
        return 'An error occurred. Please try again.';
      }

      if (data.errors && typeof data.errors === 'object') {
        const firstKey = Object.keys(data.errors)[0];
        const firstError = data.errors[firstKey];
        if (Array.isArray(firstError) && firstError.length) {
          return firstError[0];
        }
      }

      return data.message || 'An error occurred. Please try again.';
    },
    closeSaleSkinModal() {
      this.$emit('closeSaleSkinModal')
    },
    async submitOffer() {
      this.error = '';
      this.isLoading = true;

      try {
        const response = await this.$http.post(process.env.VUE_APP_API + 'offer/create', {
          title: this.formData.skinName,
          price: this.formData.desiredPrice,
          quality: this.formData.exterior,
          item_url: this.formData.steamLink,
          currency: this.currency || 'EUR'
        });

        if (response.data.status === 'OK') {
          // Reset form
          this.formData = {
            skinName: '',
            desiredPrice: '',
            exterior: '',
            steamLink: ''
          };
          // Close modal
          this.$emit('closeSaleSkinModal');
          // Redirect to success page
          this.$router.push('/offer-sent-succes');
        } else {
          this.error = response.data.message || 'Failed to submit offer. Please try again.';
        }
      } catch (error) {
        console.error('Error submitting offer:', error);
        this.error = this.extractApiErrorMessage(error);
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.sale-skin-modal .select {
  width: 70%;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 16px;
  padding: 15px 48px 15px 22px;
  border: 0;
  border-radius: 6px;
  background-color: #F0F2F3;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #363D47;
  outline: 0;
}

.error-desc {
  margin-top: 16px;
}
</style>
